<form
    class="flex xl:flex-row justify-between xl:items-center lg:flex-col lg:items-start sm:flex-row  flex-col items-center w-full"
    [formGroup]="form">
    <mat-form-field class="sm:w-[300px] w-full" *ngIf="options.length > 0" appearance="outline" color="accent">
        <mat-label>
            <span class="text-sm">{{(('Search By' | translate) | async)}}</span>
        </mat-label>
        <mat-select class="search-select text-sm sm:w-9/12 w-full" color="accent" formControlName="searchBy">
            <mat-option class="text-sm" color="accent" *ngFor="let op of options" [value]="op">
                {{(op | translate) | async}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- <mat-form-field appearance="fill" *ngIf="form.get('searchBy')?.value">
        <mat-label>{{('searchBy' | translate) + ' ' + (form.get('searchBy')?.value | translate)}}</mat-label>
        <input matInput formControlName="searchFor">
    </mat-form-field> -->
    <div class="w-full">
        <records-table-filter *ngIf="form.get('searchBy')?.value" [label]="form.get('searchBy')?.value">
        </records-table-filter>
    </div>

</form>